import { createSelector } from 'reselect';
import { getRecaptchaSiteKey, getCanonical } from 'store/selectors/application';

export default createSelector(
	getRecaptchaSiteKey,
	getCanonical('/contact-selfstorage'),
	(recaptchaSiteKey, canonical) => ({ recaptchaSiteKey, canonical }),
);
